import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  button: {
    position: "relative",
    minWidth: 24,
    minHeight: 24,
    margin: "0 20px 0 0",
    padding: 0,
    border: 0,
    outline: 0,
    cursor: "pointer",
    background: "transparent",
    fill: theme.palette.grey[700],
    borderRadius: 1,
    "&::after": {
      content: "''",
      position: "absolute",
      top: -8,
      right: -8,
      height: 40,
      borderRight: `1px solid ${theme.palette.grey[400]}`,
    },
    "&:focus": {
      "&::before": {
        boxShadow: `0 0 6px ${theme.palette.primary.main}`,
      },
    },
    "& > svg": {
      position: "relative",
      fill: "inherit",
      width: 16,
      height: 16,
    },
  },
  buttonSmall: {
    "&::before": {
      top: -3,
      right: -10,
      bottom: -3,
      left: -10,
    },
    "&::after": {
      top: -6,
      height: 36,
    },
  },
  buttonError: {
    "&::after": {
      borderRight: `1px solid ${theme.palette.error.main}`,
    },
  },
  icon: {
    position: "relative",
    fill: theme.palette.grey[700],
  },
}));

export const useInputLabelStyles = makeStyles(() => ({
  root: {
    transform: "translate(54px, -4px) scale(0.75) !important",
  },
  marginDense: {},
}));

export const useInputStyles = makeStyles(() => ({
  root: {
    "& > fieldset": {
      "& > legend": {
        marginLeft: 40,
      },
    },
  },
  input: {},
  marginDense: {},
  disabled: {
    "& > fieldset": {},
  },
  adornedStart: {
    paddingLeft: 8,
  },
}));

export const useFormHelperTextStyles = makeStyles(() => ({
  root: {
    marginLeft: 48,
  },
}));
